import { environment } from './environment';

/**
 * Neutralise les logs verbeux (`console.log` / `debug` / `info` / `trace`) en
 * production afin de ne pas polluer la console du navigateur des utilisateurs.
 *
 * `console.warn` et `console.error` sont volontairement conserves : ils servent
 * de diagnostics reels (erreurs, deprecations) et restent utiles en prod.
 *
 * A appeler tout en haut des points d'entree (`main.ts`, `messagerie-main.ts`),
 * avant le bootstrap de l'application.
 */
export function disableVerboseConsoleInProd(): void {
    if (!environment.production) {
        return;
    }

    const noop = (): void => undefined;
    const verboseMethods: Array<'log' | 'debug' | 'info' | 'trace'> = [
        'log',
        'debug',
        'info',
        'trace',
    ];

    for (const method of verboseMethods) {
        try {
            (console as unknown as Record<string, unknown>)[method] = noop;
        } catch {
            // Certains environnements protegent l'objet console : on ignore.
        }
    }
}
